import React from "react";

// Style
import { Svg } from "./styles";

const Cylinder = ({ size = 60 }) => {
  return (
    <Svg width={size} height={size} xmlns="http://www.w3.org/2000/svg">
      <circle
        cx={`${size / 2}`}
        cy={`${size / 2}`}
        r={`${size / 2}`}
        viewBox={`0 0 24 24`}
      />
    </Svg>
  );
};

export default Cylinder;
